import { useState } from "react";

const faqs = [
  {
    q: "How do I contact Harambee Global Ventures?",
    a: "The easiest way to reach us is through the contact form on this page. Simply complete the form with your name, email, inquiry type, and message, and our team will respond within 2–3 business days. You can also reach out through our advisory or partnerships pages for more specific inquiries.",
  },
  {
    q: "Can I request a consultation?",
    a: "Yes. Qualified individuals and organizations are welcome to request an advisory consultation. Visit our Advisory page to learn more about our consultation services and submit a consultation request. Consultations are available for investor readiness, financial education, and strategic cross-border guidance, but they do not constitute a public offering, solicitation of securities, or personalized investment advice.",
  },
  {
    q: "Who should use this contact form?",
    a: "This form is designed for anyone who wants to connect with Harambee Global Ventures — including African Diaspora professionals, emerging investors, entrepreneurs, families, institutions, community organizations, and strategic partners. Whether you have a specific question or simply want to introduce yourself, we welcome your message.",
  },
  {
    q: "Can organizations submit partnership inquiries through this form?",
    a: "Yes, organizations are welcome to use this form for initial inquiries. However, for a more detailed partnership conversation, we recommend visiting our Partnerships page and completing the dedicated Partnership Inquiry Form. This ensures your submission is routed directly to our partnerships team for a more tailored response.",
  },
  {
    q: "How long does it take to receive a response?",
    a: "Our team aims to respond to all inquiries within 2–3 business days. For more complex or detailed inquiries, it may take slightly longer to provide a thorough and thoughtful response. We appreciate your patience and are committed to engaging with every message we receive.",
  },
];

export default function ContactFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-14">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            FAQ
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            Have a question that isn&apos;t answered here? We are happy to help. Use the contact form and our team will respond promptly.
          </p>
          <a
            href="#contact-form"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#1A4D3C] text-white text-sm font-medium hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Ask Us Directly <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="lg:col-span-3 space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F8F6F3] border border-[#E8E4DC] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-[#2B2D2F] text-sm pr-4 group-hover:text-[#1A4D3C] transition-colors">
                  {faq.q}
                </span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white flex-shrink-0">
                  <i
                    className={`text-[#1A4D3C] text-base transition-transform duration-300 ${
                      open === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-6">
                  <p className="text-[#6B6B6B] text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
